import { useSearchParams } from 'next/navigation';

export const useTeamEditParams = () => {
	const searchParams = useSearchParams();

	const isEditMode = searchParams.get('mode') === 'edit';
	const teamParam = searchParams.get('team');

	const isEditingAwayTeam = teamParam === 'away';
	const isEditingHomeTeam = teamParam === 'home';

	return {
		isEditMode,
		teamParam,
		isEditingAwayTeam,
		isEditingHomeTeam
	};
};
